import {Component, Inject, inject, Input, OnInit, HostBinding} from '@angular/core';
import {DataEntity} from 'octopus-connect';
import {ReviewChoices, UserReviewService} from 'fuse-core/components/user-review/user-review.service';
import {AuthenticationService} from '@modules/authentication';
import {FormBuilder} from '@angular/forms';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-user-review-mobile',
    templateUrl: './user-review-mobile.component.html',
    styleUrls: ['./user-review-mobile.component.scss'],
    animations: [
        trigger('fadeAndSlideInAndOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(100%)' }),
                animate('600ms ease-in-out', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'translateY(0)' }),
                animate('600ms ease-in-out', style({ opacity: 0, transform: 'translateY(100%)' })),
            ]),
        ]),
    ],
    standalone: false
})

export class UserReviewMobileComponent implements OnInit {
    private userReviewService = inject(UserReviewService);
    private authService = inject(AuthenticationService);
    public uid: number;
    public type: string;
    public itemToReview: DataEntity;
    reviewChoice: ReviewChoices;

    @HostBinding('@fadeAndSlideInAndOut') animate = true; // Apply entry and leave animations on host element

    constructor(
        private formBuilder: FormBuilder,
        @Inject(MAT_BOTTOM_SHEET_DATA) data,
        private _bottomSheetRef: MatBottomSheetRef<UserReviewMobileComponent>,
    ) {
        this.uid = data?.uid;
        this.type = data?.type;
        this.itemToReview = data?.itemToReview;
    }

    ngOnInit(): void {
    }

    selectReviewChoice(value: ReviewChoices): void {
        if (value !== this.reviewChoice && this.itemToReview) {
            const reviewToSave = {
                nid: this.itemToReview.id.toString(),
                uid: this.authService.loggedUser.id.toString(),
                value: value
            };
            this.userReviewService.saveUserReview(reviewToSave).subscribe();
            this._bottomSheetRef.dismiss('Form submitted');
        }
        this.reviewChoice = value;
    }

    public isUserAtLeastTrainer(): boolean {
        return this.authService.isAtLeastTrainer();
    }

    public notNowAction() {
        // set displayNps to 'update' to process on the backoffice side
        this.authService.loggedUser.set('displayUserReview', 'update');
        this.authService.loggedUser.save();
        this._bottomSheetRef.dismiss('Not now button click');
    }

    protected readonly ReviewChoices = ReviewChoices;
}